<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col-12">
        <button @click="goBack" class="btn btn-secondary mb-3">
          <font-awesome-icon icon="arrow-left" /> Zurück zur Übersicht <!-- Verwende icon="arrow-left" -->
        </button>
      </div>
    </div>
    
    <h2 class="text-center mb-4">Kunden Übersicht</h2>

    <!-- Suchfeld -->
    <div class="row">
      <div class="col-12 col-md-6 mx-auto">
        <input type="text" v-model="searchQuery" class="form-control mb-3" placeholder="Suche Kunden..." />
      </div>
    </div>

    <div v-if="loading" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Laden...</span>
      </div>
    </div>
    <!-- Tabelle -->
    <div v-else class="table-responsive">
      <table class="table table-striped table-hover table-bordered">
        <thead class="table-light">
          <tr>
            <th>ID</th>
            <th>Vorname</th>
            <th>Nachname</th>
            <th>Straße</th>
            <th>Ort</th>
            <th>PLZ</th>
            <th>Telefon</th>
            <th>E-Mail</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="customer in filteredCustomers" :key="customer.id">
            <td data-label="ID">{{ customer.id }}</td>
            <td data-label="Vorname">{{ customer.FirstName }}</td>
            <td data-label="Nachname">{{ customer.LastName }}</td>
            <td data-label="Straße">{{ customer.Street }}</td>
            <td data-label="Ort">{{ customer.City }}</td>
            <td data-label="PLZ">{{ customer.PostalCode }}</td>
            <td data-label="Telefon">{{ customer.Phone }}</td>
            <td data-label="E-Mail">{{ customer.Email }}</td>
            <td data-label="Aktionen">
              <button class="btn btn-warning btn-sm me-2" @click="editCustomer(customer.id)">
                <font-awesome-icon icon="edit" class="me-2" /> Bearbeiten <!-- Verwende icon="edit" -->
              </button>
              <button class="btn btn-danger btn-sm" @click="confirmDelete(customer)">
                <font-awesome-icon icon="trash" class="me-2" /> Löschen <!-- Verwende icon="trash" -->
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Bestätigungsmodal -->
    <div v-if="customerToDelete" class="modal fade show" style="display: block;" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Löschbestätigung</h5>
          </div>
          <div class="modal-body">
            <p>Möchten Sie den Kunden {{ customerToDelete.FirstName }} {{ customerToDelete.LastName }} wirklich löschen?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="cancelDelete">Abbrechen</button>
            <button type="button" class="btn btn-danger" @click="deleteCustomer">Löschen</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/services/axios';

export default {
  name: 'CustomerOverview',
  data() {
    return {
      customers: [],
      searchQuery: '',
      customerToDelete: null,
      loading: false
    };
  },
  computed: {
    filteredCustomers() {
      return this.customers.filter(customer =>
        String(customer.id).includes(this.searchQuery.toLowerCase()) ||
        customer.FirstName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        customer.LastName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        (customer.Street && customer.Street.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
        (customer.City && customer.City.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
        (customer.PostalCode && customer.PostalCode.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
        (customer.Phone && customer.Phone.toLowerCase().includes(this.searchQuery.toLowerCase())) ||
        (customer.Email && customer.Email.toLowerCase().includes(this.searchQuery.toLowerCase()))
      );
    }
  },
  methods: {
    async fetchCustomers() {
      this.loading = true;
      try {
        const response = await axios.get('/customers');
        this.customers = response.data;
      } catch (error) {
        console.error('Fehler beim Abrufen der Kunden:', error);
      } finally {
        this.loading = false;
      }
    },
    editCustomer(id) {
      this.$router.push({ name: 'EditCustomer', params: { id } });
    },
    confirmDelete(customer) {
      this.customerToDelete = customer;
    },
    cancelDelete() {
      this.customerToDelete = null;
    },
    async deleteCustomer() {
      try {
        await axios.delete(`/customers/${this.customerToDelete.id}`);
        this.customers = this.customers.filter(c => c.id !== this.customerToDelete.id);
        this.customerToDelete = null;
      } catch (error) {
        console.error('Fehler beim Löschen des Kunden:', error);
      }
    },
    goBack() {
      this.$router.push('/customers');
    }
  },
  created() {
    this.fetchCustomers();
  }
};
</script>


<style scoped>
/* Maximale Breite der Tabelle für größere Bildschirme */
.table-responsive {
  max-width: 100%;
}

/* Stil für die Tabelle */
.table {
  margin-top: 20px;
}

.table th,
.table td {
  vertical-align: middle;
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 123, 255, 0.1);
  /* Leichtes Blau für Hover */
}

.btn-warning {
  background-color: var(--primary-color);
  border: none;
  color: white;
  transition: background-color 0.3s ease;
}

.btn-sm.me-2 {
  margin-right: 10px;
}

.btn-warning:hover {
  background-color: var(--secondary-color);
}

/* Responsive Darstellung für die Tabelle auf mobilen Geräten */
@media (max-width: 768px) {

  .table-responsive table,
  .table-responsive thead,
  .table-responsive tbody,
  .table-responsive th,
  .table-responsive td,
  .table-responsive tr {
    display: block;
  }

  .table-responsive tr {
    margin-bottom: 1rem;
    border-bottom: 1px solid #ddd;
  }

  .table-responsive td {
    text-align: right;
    padding-left: 50%;
    position: relative;
  }

  .table-responsive td::before {
    content: attr(data-label);
    position: absolute;
    left: 0;
    width: 45%;
    padding-left: 1rem;
    font-weight: bold;
    text-align: left;
    color: #333;
  }

  .table th {
    display: none;
  }
}
</style>
